/**
 * SEPETE EKLE — görev değiştiren CTA
 *
 * Aritzia deseni: buton ölü griye dönmez, GÖREV değiştirir.
 *   beden seçilmedi → çerçeve, "BEDEN SEÇİN"  (tıklayınca beden seçiciye götürür)
 *   beden seçildi   → dolu,    "SEPETE EKLE — 999,00 TL"
 *   tükendi         → çerçeve, "GELİNCE HABER VER"
 *
 * NEDEN: Bedeni bilinçli seçtirmek yanlış-beden iadelerini düşürür.
 * Shopify varsayılanı ilk bedeni otomatik seçer — müşteri farkına varmadan
 * S sipariş eder, M bekler. Bu davranışı kasten kırıyoruz.
 */
(function () {
  'use strict';

  function paraFormat(kurus) {
    var t = (kurus / 100).toFixed(2).replace('.', ',');
    return t.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' TL';
  }

  document.querySelectorAll('[data-mb-atc]').forEach(function (btn) {
    if (btn.dataset.mbBound) return;
    btn.dataset.mbBound = '1';

    var form = btn.closest('form');
    var kok = btn.closest('.product') || document;
    var yazi = btn.querySelector('[data-mb-atc-yazi]');
    var bedenSecilmeli = btn.dataset.mbBedenSecilmeli === 'true';
    var metinSepet = btn.dataset.mbMetinSepet || 'Sepete Ekle';

    // Tükendiyse hiç dokunma — "Gelince Haber Ver" kalır
    if (btn.classList.contains('is-tukendi')) return;
    if (!bedenSecilmeli) return;

    // URL'de ?variant= varsa kullanıcı zaten bir beden seçmiş sayılır
    var urlVaryant = new URLSearchParams(window.location.search).has('variant');
    var secildi = urlVaryant;

    function bedenSecicisi() {
      var alanlar = kok.querySelectorAll('.product-form__input');
      for (var i = 0; i < alanlar.length; i++) {
        var etiket = alanlar[i].querySelector('legend, .form__label');
        if (!etiket) continue;
        var ad = etiket.textContent.toLowerCase();
        if (ad.indexOf('beden') > -1 || ad.indexOf('size') > -1 || ad.indexOf('numara') > -1) {
          return alanlar[i];
        }
      }
      return null;
    }

    function bedenSecBoyu() {
      btn.classList.add('mb-atc--outline', 'is-beden-bekliyor');
      yazi.innerHTML = 'Beden Seçin';
    }

    function sepetBoyu() {
      btn.classList.remove('mb-atc--outline', 'is-beden-bekliyor');
      var fiyat = '';
      var fEl = document.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');
      if (fEl) fiyat = fEl.textContent.trim();
      yazi.innerHTML = metinSepet + (fiyat ? ' <span class="mb-atc__fiyat">&mdash; ' + fiyat + '</span>' : '');
    }

    if (!secildi) bedenSecBoyu();

    // Beden seçilince butonu doldur
    kok.addEventListener('change', function (e) {
      if (!e.target.closest('.product-form__input')) return;
      secildi = true;
      // Fiyat DOM'u Dawn tarafından güncellenene kadar bekle
      setTimeout(sepetBoyu, 60);
    });

    // "Beden Seçin" hâlindeyken tıklama → sepete ekleme, beden seçiciye götür
    btn.addEventListener(
      'click',
      function (e) {
        if (!btn.classList.contains('is-beden-bekliyor')) return;
        e.preventDefault();
        e.stopPropagation();

        var secici = bedenSecicisi();
        if (!secici) return;

        secici.scrollIntoView({ behavior: 'smooth', block: 'center' });
        secici.classList.add('mb-uyar');
        setTimeout(function () { secici.classList.remove('mb-uyar'); }, 1200);

        var ilk = secici.querySelector('input[type="radio"], select');
        if (ilk) ilk.focus({ preventScroll: true });
      },
      true // capture — Dawn'ın submit'inden önce yakala
    );

    if (form) {
      form.addEventListener('submit', function (e) {
        if (btn.classList.contains('is-beden-bekliyor')) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }, true);
    }
  });
})();
